export function isSupportConsole() {
  return _isSupportConsole(import.meta.env.VITE_SITE_PROFILE);
}
function _isSupportConsole(supportConsole) {
  return ["support-console"].includes(supportConsole);
}
